var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"font-button text-button text-white p-3 rounded-full",class:_vm.getBackgroundColor(),on:{"click":function($event){return _vm.handleClick()}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }